import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'loyaltyDisplayAddReceipt',
  initialState: false,
  reducers: {
    setLoyaltyDisplayAddReceipt(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setLoyaltyDisplayAddReceipt } = slice.actions;

export default slice.reducer;
